<template>
  <div>
    <h3>1、如何获得？</h3>
    <p>通过【推荐达人】获得，【新用户】在<span style="color: #ff4d4f">首次</span>购买产品时输入推荐人的手机号
      <span style="color: #ff4d4f">（推荐人的手机号在账号有效期内）</span>
      ，购买完成后，购买者和推荐人的两个手机 号将同时获得相同的积分。</p>
    <p></p>
    <h3>2、积分规则？</h3>
    <p>根据产品的类型进行积分：</p>
    <p>▶ 1个月产品积分5</p>
    <p>▶ 12个月产品积分10</p>
    <p>▶ 24月产品积分20</p>
    <p>▶ 长期有效产品积分50</p>
    <p></p>
    <h3>3、如何使用？</h3>
    <p>购买产品时，<span style="color: #ff4d4f">在最高使用积分额度以下，</span>按1积分抵扣1元的方式直接抵扣产品金额。额度规则如下：</p>
    <el-table
      :data="tableData"
      max-height="600px">
      <el-table-column property="title" label="产品" width="200" header-align="center" align="center"></el-table-column>
      <el-table-column property="max1" label="1个月" width="120" header-align="center" align="center"></el-table-column>
      <el-table-column property="max2" label="12个月" width="120" header-align="center" align="center"></el-table-column>
      <el-table-column property="max3" label="24个月" width="120" header-align="center" align="center"></el-table-column>
      <el-table-column property="max4" label="长期有效" width="120" header-align="center" align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'Points',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  props: {
    myList: {
      type: Array
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.myList.map(item => {
      this.tableData.push({
        'title': item.title,
        'max1': item.values[0].max / 100,
        'max2': item.values[1].max / 100,
        'max3': item.values[2].max / 100,
        'max4': item.values[3].max / 100
      })
    })
    // console.log(this.tableData)
    // this.tableData = this.myList
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
}
</style>

